export default __webpack_public_path__ + "static/media/3rdBlog.2fa8e7b3.jpg";